// noinspection JSUnusedGlobalSymbols

/**
 * Key to store tokens in storage.
 * @default Access-Token
 * @author Kacper Faber
 */
const tokenKey: string = "Access-Token";

/**
 * Static class to work with storage.
 * In storage, we store data like access tokens.
 * @author Kacper Faber
 */
class Storage {
    /**
     * Updates token in storage.
     * Will set `tokenKey` in storage to given value.
     * Will remove element from storage, if given value is null or undefined.
     * @param token Value to save, or delete.
     * @author Kacper Faber
     */
    static setToken(token: string | null | undefined) {
        if (token === null || token === undefined) {
            window.sessionStorage.removeItem(tokenKey);
            return;
        }

        window.sessionStorage.setItem(tokenKey, token);
    }

    /**
     * Get token from storage.
     * @returns token from storage or null.
     * @author Kacper Faber
     */
    static getToken(): string | null {
        return window.sessionStorage.getItem(tokenKey);
    }
}

export default Storage;